import Serology from './Serology';

export default Serology;
